import { Instagram, Facebook, Mail, MapPin } from "lucide-react";
import { LogoMark } from "./Logo";
import { BRAND, HEART_FLAG_URL } from "@/brand";

export const Footer = () => (
    <footer className="border-t border-white/10 bg-coal" data-testid="footer">
        <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
            <div className="flex flex-col gap-12 md:flex-row md:items-start md:justify-between">
                <div>
                    <div className="flex items-center gap-3">
                        <LogoMark className="h-10 w-10" />
                        <span className="font-display text-xl font-extrabold uppercase tracking-tight text-parchment">
                            SpiceJam <span className="text-nutmeg">Kitchen</span>
                        </span>
                        {HEART_FLAG_URL && (
                            <img
                                src={HEART_FLAG_URL}
                                alt="Grenada x Jamaica heart flag"
                                className="h-9 w-auto"
                                data-testid="footer-heart-flag"
                            />
                        )}
                    </div>
                    <p className="mt-4 max-w-xs font-editorial text-base italic text-sand/80">
                        {BRAND.tagline}
                    </p>
                    <p className="mt-6 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-sand/60">
                        <MapPin className="h-3.5 w-3.5 text-bonnetglow" />
                        {BRAND.location}
                    </p>
                </div>

                <div className="flex flex-col gap-8 sm:flex-row sm:gap-16">
                    <div>
                        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-sand/50">Contact</p>
                        <a
                            href={`mailto:${BRAND.email}`}
                            className="mt-4 flex items-center gap-2 text-sm font-semibold text-parchment transition-colors duration-300 hover:text-nutmeg"
                            data-testid="footer-email"
                        >
                            <Mail className="h-4 w-4 text-nutmeg" />
                            {BRAND.email}
                        </a>
                    </div>
                    <div>
                        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-sand/50">Follow</p>
                        <div className="mt-4 flex gap-3">
                            <a
                                href={BRAND.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-sand transition-[border-color,color,transform] duration-300 hover:-translate-y-0.5 hover:border-nutmeg/60 hover:text-nutmeg"
                                data-testid="footer-social-instagram"
                            >
                                <Instagram className="h-4 w-4" />
                            </a>
                            <a
                                href={BRAND.facebook}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-sand transition-[border-color,color,transform] duration-300 hover:-translate-y-0.5 hover:border-nutmeg/60 hover:text-nutmeg"
                                data-testid="footer-social-facebook"
                            >
                                <Facebook className="h-4 w-4" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-8 text-xs text-sand/50 sm:flex-row sm:items-center sm:justify-between">
                <p data-testid="footer-copyright">© 2026 SPICEJAM KITCHEN · Ontario, Canada</p>
                <p className="font-editorial italic">Small-batch, always. No shortcuts.</p>
            </div>
        </div>
    </footer>
);

export default Footer;
